"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _uiKit = require("@dbi-tools/ui-kit");

var _headerTitles = require("../header-titles");

var _linkButtons = _interopRequireDefault(require("../link-buttons"));

var _useMedia = require("../../hooks/use-media");

var _const = require("../../const");

var _tabs = require("./tabs.styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var TabsUi = function TabsUi(props) {
  var headline1 = props.headline1,
      headline2 = props.headline2,
      description = props.description,
      removeBottomPadding = props.removeBottomPadding,
      removeTopPadding = props.removeTopPadding,
      id = props.id,
      _props$buttons = props.buttons,
      buttons = _props$buttons === void 0 ? [] : _props$buttons,
      activeItem = props.activeItem,
      _props$items = props.items,
      items = _props$items === void 0 ? [] : _props$items,
      accessibilityLabel = props.accessibilityLabel,
      _props$children = props.children,
      children = _props$children === void 0 ? [] : _props$children;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      activeIndex = _useState2[0],
      setActiveIndex = _useState2[1];

  var isMobile = (0, _useMedia.useMedia)(_const.Breakpoints.MOBILE);
  var defaultPadding = isMobile ? 30 : 60;
  var bottomIndent = removeBottomPadding ? 0 : defaultPadding;
  var topIndent = removeTopPadding ? 0 : defaultPadding;
  var containerIndent = [topIndent, 0, bottomIndent];
  (0, _react.useEffect)(function () {
    if (!items || items.length === 0) return;
    setActiveIndex(items.findIndex(function (_ref) {
      var name = _ref.name;
      return name === activeItem;
    }));
  }, []);

  if ((0, _isEmpty.default)(items)) {
    return /*#__PURE__*/_react.default.createElement(_uiKit.Heading, {
      align: "center",
      as: "h2",
      fontWeight: "bold",
      measure: "h1"
    }, "Please configure TABS component");
  }

  return /*#__PURE__*/_react.default.createElement(_tabs.StyledBox, {
    id: id,
    p: containerIndent
  }, /*#__PURE__*/_react.default.createElement(_tabs.StyledContainer, null, /*#__PURE__*/_react.default.createElement(_headerTitles.HeaderTitles, {
    headline1: headline1,
    headline2: headline2,
    description: description,
    headline1Color: 'primaryDark',
    headline2Color: 'gray800',
    noGutters: true,
    mb: 25
  }), /*#__PURE__*/_react.default.createElement(_tabs.TabsButtons, {
    role: "tablist",
    "aria-label": accessibilityLabel,
    "aria-multiselectable": "false"
  }, items.map(function (_ref2, index) {
    var title = _ref2.title;
    var isActive = index === activeIndex;
    return /*#__PURE__*/_react.default.createElement(_tabs.TabsButton, {
      role: "tab",
      key: 'tab-' + index,
      onClick: function onClick() {
        return setActiveIndex(index);
      },
      className: isActive ? 'active' : '',
      tabIndex: isActive ? 0 : -1,
      "data-cmp-hook-tabs": "tab"
    }, title);
  })), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children.map(function (item, index) {
    var isVisible = activeIndex === index;
    var styles = {
      display: !isVisible ? 'none' : 'block'
    };
    return /*#__PURE__*/_react.default.createElement("div", {
      key: 'tab-content-' + index,
      style: styles
    }, item);
  })), !!buttons.length && /*#__PURE__*/_react.default.createElement(_linkButtons.default, {
    mt: 45,
    buttons: buttons,
    color: "gray800"
  })));
};

var _default = TabsUi;
exports.default = _default;